import { ActionTypes } from '../constants/index';

export const getSessionInfo = (payload: any) => ({
  type: ActionTypes.SESSION_INFO_LIST_REQUEST,
  payload,
});
